import React, { useEffect, useState } from 'react';
import { detectInAppBrowser, InAppBrowserApp } from 'utils/detectInAppBrowser';

const messages: Record<Exclude<InAppBrowserApp, null>, string> = {
    instagram: 'Instagram’s in-app browser may hide parts of the page.',
    facebook: 'Facebook’s browser can cause display or login issues.',
    tiktok: 'TikTok’s in-app browser can limit functionality.',
    twitter: 'Twitter’s browser may block some features.',
    linkedin: 'LinkedIn’s browser may affect performance.',
    snapchat: 'Snapchat’s browser can interfere with layout.',
    reddit: 'Reddit’s browser may not render this app correctly.',
};

export const OpenInBrowserBanner: React.FC = () => {
    const [app, setApp] = useState<InAppBrowserApp>(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const detected = detectInAppBrowser();
        if (detected) {
            setApp(detected);
            setVisible(true);
        }
    }, []);

    if (!app || !visible) return null;

    const message = messages[app];
    const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent);

    const handleOpen = () => {
        if (isIOS) {
            alert(
                "On iPhone: Tap the share icon (square with an arrow) or the ••• menu, then choose 'Open in external browser'."
            );
        } else {
            window.open(window.location.href, '_blank');
        }
    };

    return (
        <div
            style={{
                position: 'fixed',
                inset: 0,
                backgroundColor: 'rgba(0,0,0,0.5)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 9999,
            }}
            onClick={() => setVisible(false)} // clicking the backdrop closes the modal
        >
            <div
                style={{
                    backgroundColor: '#fff',
                    color: '#333',
                    borderRadius: '12px',
                    padding: '1.5rem 1.25rem',
                    maxWidth: '90%',
                    width: '400px',
                    boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
                    textAlign: 'center',
                }}
                onClick={e => e.stopPropagation()} // prevent closing when clicking inside
            >
                <h3
                    style={{
                        marginBottom: '0.75rem',
                        fontSize: '1.25rem',
                        color: 'rgb(1, 84, 255)',
                    }}>
                    Open in Your Browser
                </h3>
                <p style={{ marginBottom: '1rem', fontSize: '0.95rem', lineHeight: 1.4 }}>
                    {message}
                </p>

                <div style={{ display: 'flex', justifyContent: 'center', gap: '0.75rem' }}>
                    <button
                        onClick={handleOpen}
                        style={{
                            backgroundColor: 'rgb(1, 84, 255)',
                            color: 'white',
                            border: 'none',
                            borderRadius: '6px',
                            padding: '0.5rem 1rem',
                            fontWeight: 600,
                            cursor: 'pointer',
                        }}>
                        Open in Browser
                    </button>
                    <button
                        onClick={() => setVisible(false)}
                        style={{
                            backgroundColor: '#eee',
                            color: '#333',
                            border: 'none',
                            borderRadius: '6px',
                            padding: '0.5rem 1rem',
                            cursor: 'pointer',
                        }}>
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};
